
import { certificationImages } from '../../../utils/images';

export default function CertificationsSection() {
  const certifications = [
    { name: "BSCI", image: certificationImages.bsci },
    { name: "SEDEX", image: certificationImages.sedex },
    { name: "LWG", image: certificationImages.lwg },
    { name: "RDS", image: certificationImages.rds },
    { name: "GRS", image: certificationImages.grs },
    { name: "ISO 9001", image: certificationImages.iso9001 },
    { name: "ISO 14001", image: certificationImages.iso14001 }
  ];

  return (
    <section className="py-20 bg-white text-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-light leading-tight mb-6">
            Our Certifications
          </h2>
          <p className="text-lg text-gray-700 font-light max-w-3xl mx-auto">
            We are proudly certified by leading international organizations, reflecting our dedication to compliance and responsibility.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 lg:gap-8 items-center">
          {certifications.map((cert, index) => (
            <div key={index} className="text-center group flex-shrink-0">
              <div className="w-32 h-32 mx-auto mb-3 group-hover:scale-105 transition-all duration-300">
                <img
                  src={cert.image}
                  alt={cert.name}
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
